<div class="root" *transloco="let t; read:'permit.prepare'">
    <div class="root__loader" *ngIf="loading$ | async"></div>
    <ng-container *ngIf="(loading$ | async) === false">
        <h1 *ngIf="isRetrieveFlammableAtexPermit" class="root__heading">{{ t("retrievableFlammableAtexPermitsHeading") }}</h1>

        <div class="root__intro">{{ t((permits$ | async)?.length > 0
            ? (isRetrieveFlammableAtexPermit ? "retrievableFlammableAtexPermitsListIntro" : "preparedPermitsListIntro")
            : (isRetrieveFlammableAtexPermit ? "retrievableFlammableAtexPermitsNotFound" : "preparedPermitsNotFound")) }}</div>

        <div class="root__error" *ngIf="isRetrieveFlammableAtexPermit && (errorMessage$ | async) as errorMessage">{{ errorMessage }}</div>

        <div class="root__list" *ngIf="(permits$ | async)?.length > 0 && permits$ | async as permits">
            <pmt-prepared-permit-list-item
                *ngFor="let permit of permits"
                [item]="permit"
                [hotWorkPermitId]="permitId"
                [retrieveFlammableAtexPermitMode]="isRetrieveFlammableAtexPermit">
            </pmt-prepared-permit-list-item>
        </div>

        <div class="root__refresh" (click)="refresh()">{{ t("refresh") }}</div>
    </ng-container>
    <div class="root__actions">
        <button class="root__actions__cancel" (click)="cancel()">{{ t(isRetrieveFlammableAtexPermit ? "back" : "cancel") }}</button>
    </div>
</div>
